import { Helmet } from 'react-helmet-async';

export const DefaultMeta = () => {
  return (
    <Helmet>
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="FameCreator" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:image" content="/webclip.jpeg" />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@famecreator" />
      <meta name="twitter:creator" content="@famecreator" />
      <meta name="twitter:image" content="/webclip.jpeg" />

      <link rel="apple-touch-icon" href="/webclip.jpeg" />
      <meta name="theme-color" content="#000000" />
    </Helmet>
  );
};
